import { FormsService } from "./../../../services/forms/forms.service";
import { put } from "@redux-saga/core/effects";

import { ChangeConfigActionType } from "./../types";
import { changeConfigsSuccess } from "./../actionCreators";
import { CreateFormResponse } from "./../../../services/forms";
import { refreshLayout } from "../../layout/actionCreators";

export function* changeConfig({ payload: { path, value } }: ChangeConfigActionType) {
    try {
        const {
            data: { data: response },
        }: CreateFormResponse = yield FormsService.updateFormComponent({
            data: [{ [path]: value }],
        });
        yield put(changeConfigsSuccess({ config: response.config }));
        yield put(refreshLayout({}));
    } catch (error) {
        // yield put(Handle Error);
    }
}
